import '../App.css';
import az from "../images/az_scaled.jpg"
import ce from "../images/ce_scaled.png"
import nd from "../images/nd_scaled.jpg"
import sf from "../images/sf_scaled.png"
import scribble from "../images/scribble4.png"


function About() {
    return (
        <div className="App-body">
            <div className='App-photo-gallery'>
                <img src={az} alt="me in Atlanta" className='App-image' />
                <img src={ce} alt="me in Cairo" className='App-image' />
                <img src={nd} alt="me on a dance floor in Delhi" className='App-image' />
                <img src={sf} alt="me in San Francisco" className='App-image' />
            </div>
            <p>
                My name is Bhargav Annigeri.
            </p>
            <p>
                I'm originally from Portland, Oregon, and after spending some time in Atlanta and Seattle I now live in Brooklyn, New York.
            </p>
            <p>
                I produce music, playing guitar and drums.
                I also like writing about the music and movies I engage with.
                I'm always trying to expand my artistic engagement and learn about whatever I don't already know.
            </p>
            <p>
                Hoping to use this site as a repository for any projects and interests I'd like to surface and as a way for collaborators or peers to get in touch!
            </p>
            <p>
                Click around to learn about my work, regular updates on what I'm reading/watching/listening to, or to reach out!
            </p>
            <img src={scribble} alt="" style={{height:"18vh", marginTop:"5vh"}} onContextMenu={()=>{return false;}} draggable={false}/>
        </div>
    );
}

export default About;